(function() {
  // --- força o texto "Comprar agora" no tema Craft ---
  try {
    window.variantStrings = window.variantStrings || {};
    window.variantStrings.addToCart = 'Comprar agora';
  } catch (e) {}

  // função que garante o label mesmo após trocas de variante
  function forceBuyNowLabel(scope) {
    var btn = (scope || document).querySelector('button[name="add"]');
    if (!btn) return;
    var span = btn.querySelector('span') || btn;
    if (span.textContent.trim() !== 'Comprar agora' &&
        !btn.hasAttribute('disabled')) {
      span.textContent = 'Comprar agora';
      btn.setAttribute('aria-label', 'Comprar agora');
    }
  }

  // observa mudanças de texto que o tema fizer e reverte
  var btnObserver = new MutationObserver(function() { forceBuyNowLabel(); });
  document.addEventListener('DOMContentLoaded', function() {
    forceBuyNowLabel();
    var btn = document.querySelector('button[name="add"]');
    if (btn) btnObserver.observe(btn, { childList: true, subtree: true, characterData: true });
  });

  // aplica de novo ao trocar variante (Craft dispara change no input/select id)
  document.addEventListener('change', function(e){
    if (e.target && (e.target.name === 'id' || e.target.closest('[name="id"]'))) {
      forceBuyNowLabel(document);
    }
  });

  // --- fluxo comprar agora (add.js + redirect) ---
  var forms = document.querySelectorAll('form[action*="/cart/add"]');
  forms.forEach(function(form){
    if (form.dataset.buyNowBind === '1') return;
    form.dataset.buyNowBind = '1';
    forceBuyNowLabel(form);

    form.addEventListener('submit', function(e){
      e.preventDefault();

      var submitter = e.submitter || document.activeElement;
      if (submitter) submitter.disabled = true;

      var variantInput = form.querySelector('input[name="id"]');
      var qtyInput     = form.querySelector('input[name="quantity"]');
      var planInput    = form.querySelector('[name="selling_plan"]');

      var variantId = variantInput && variantInput.value ? String(variantInput.value) : null;
      var quantity  = qtyInput && qtyInput.value ? parseInt(qtyInput.value,10) : 1;
      var sellingPlanId = planInput && planInput.value ? String(planInput.value) : null;

      if (!variantId) { if (submitter) submitter.disabled = false; return form.submit(); }

      var payload = { items: [{ id: Number(variantId), quantity: quantity }] };
      if (sellingPlanId) payload.items[0].selling_plan = Number(sellingPlanId);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(r){ if (!r.ok) throw new Error('Add failed'); return r.json(); })
      .then(function(){ window.location.href = '/checkout'; })
      .catch(function(){ if (submitter) submitter.disabled = false; form.submit(); });
    });
  });
})();
